export default "__VITE_ASSET__BuRCMm0w__"